import React from "react";
import { Row, Col, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
	agencyUpserted,
	selectAllAgencies,
	selectAgencyById,
} from "./agenciesSlice";

const Agencies = () => {
	const data = useSelector(selectAllAgencies);

	return (
		<div style={{ paddingBottom: 10 }}>
			<Row
				className="agency-row"
				style={{
					fontWeight: 600,
				}}
				align="middle"
			>
				<Col span={8}>Agency</Col>
				<Col span={6}>Contact Name</Col>
				<Col span={4}>Contact Number</Col>
				<Col span={6}>Why/How They Are Involved</Col>
			</Row>
			{data.map((d) => (
				<AgencyRow id={d.id} key={d.id} />
			))}
		</div>
	);
};

const AgencyRow = ({ id }) => {
	const dispatch = useDispatch();
	const data = useSelector((state) => selectAgencyById(state, id));
	const { agency, contactName, contactNumber, whyHowInvolved } = data;

	const PrintableText = ({ value, name }) => {
		return (
			<>
				<Input
					className="print-hide"
					defaultValue={value}
					onBlur={(e) =>
						dispatch(
							agencyUpserted({
								...data,
								[name]: e.target.value,
							})
						)
					}
					style={{ width: "100%" }}
				/>
				<div
					className="print-show"
					style={{
						padding: 3,
						fontSize: "12px",
						whiteSpace: "pre-line",
						wordWrap: "break-word",
						overflowWrap: "break-word",
					}}
				>
					{value}
				</div>
			</>
		);
	};

	return (
		<Row className="agency-row" align="middle">
			<Col span={8}>{agency}</Col>
			<Col span={6}>
				<PrintableText value={contactName} name="contactName" />
			</Col>
			<Col span={4}>
				<PrintableText value={contactNumber} name="contactNumber" />
			</Col>
			<Col span={6}>
				<PrintableText value={whyHowInvolved} name="whyHowInvolved" />
			</Col>
		</Row>
	);
};

export default Agencies;
